import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            tabIndex: 0,
            openEditAddressValue: false,
            openEditRegionValue: false,
            openAddAddressValue: false,
            openAddRegionValue: false,
            regionToEdit: null,
            addressToEdit: null,
            averageRate: '',
            rates: [],
            bugs: [],
        }
    },
    computed: {
        filteredRates() {
            return this.rates.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.ratings.toString().toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.review.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.time.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.appInfo.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ;

            })
        },
        filteredBugs() {
            return this.bugs.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.report.toString().toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.time.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.appInfo.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ;
            })
        }
    },
    methods: {
        getRates: getRates,
        getBugs: getBugs,
        checkNull: checkNull,
        formatDate: formatDate,
        fixBug: fixBug,
        getModuleStyle: getModuleStyle,
        setTab: setTab,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        visibleDel: visibleDel,
        openEditRegion: openEditRegion,
        openAddRegion: openAddRegion,
        openEditAddress: openEditAddress,
        openAddAddress: openAddAddress,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.getRates();
        this.getBugs();
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function openEditAddress(address) {
    this.openEditAddressValue = true;
    this.addressToEdit = address;
}

function openEditRegion(region) {
    this.openEditRegionValue = true;
    this.regionToEdit = region;
}

function openAddRegion() {
    this.openAddRegionValue = true;
}

function openAddAddress() {
    this.openAddAddressValue = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getRates() {
    var _self = this;
    AdminApiService.getRates()
        .then((response) => {
            var amount = 0;
            response.data.forEach(e => {
                amount += e.ratings == null ? 0 : e.ratings;
            });
            var num = amount / response.data.length;
            _self.averageRate = Math.round((num + Number.EPSILON) * 100) / 100
            _self.rates = response.data.map(e => {
                return {
                    name: _self.checkNull(e.createdBy.firstName),
                    ratings: _self.checkNull(e.ratings),
                    review: _self.checkNull(e.review),
                    time: _self.checkNull(_self.formatDate(e.timestamp)),
                    appInfo: _self.checkNull(e.appInfo)
                }
            })
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getBugs() {
    var _self = this;
    AdminApiService.getBugs()
        .then((response) => {
            _self.bugs = response.data.map(e => {
                return {
                    id: e.id,
                    name: _self.checkNull(e.createdBy.firstName),
                    phoneNumber: _self.checkNull(e.createdBy.phoneNumber),
                    report: _self.checkNull(e.report),
                    time: _self.checkNull(_self.formatDate(e.timestamp)),
                    appInfo: _self.checkNull(e.appInfo)
                }
            })
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {

}



function fixBug(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da označite problem kao rešen za: " + item.name +", datum: " + item.time + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.fixBug(item.id)
            .then((response) => {
                swal('Uspešno', 'Problem uspešno rešen.', 'success')
                _self.getBugs();
            })
            .catch((error) => {

                swal('Greška', error.message, 'error')
            })
    });
}


function getModuleStyle(index) {
    if(index === this.tabIndex){
        return "background: #70b1e7; color: white;"
    }else {
        return "background: #1b1e24; color: white;"
    }
}

function setTab(tab) {
    this.filter = '';
    this.tabIndex = tab;
}
function visibleDel() {
    // return true;
    return localStorage.getItem('sb95') === 'braca'
}

function formatDate(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY HH:mm:ss')
}

function checkNull(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/components/RateAndBugs/RateAndBugs.js